import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "top-category-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { addCategoryApi } from '@/service/modules/sale';
export default /*#__PURE__*/_defineComponent({
  __name: 'top-category-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: 'addSubset'
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const form = reactive({
      name: ''
    });
    const rules = {
      name: [{
        required: true,
        message: '请输入分组名称',
        trigger: 'blur'
      }, {
        min: 2,
        max: 8,
        message: '分组名称2~8位',
        trigger: 'blur'
      }]
    };
    function restForm() {
      form.name = '';
      formRef.value?.resetFields();
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      restForm();
      emit('closeDialog');
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      let params = {
        name: form.name
      };
      if (props.dialogType === 'edit') {
        params.id = props.itemData.id;
      }
      try {
        let res = await addCategoryApi(params);
        ElMessage.success(props.dialogType === 'add' ? '添加成功' : '修改成功');
        subBtnLoading.value = false;
        closeDialog();
        emit('restData');
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    const title = computed(() => {
      if (props.dialogType === 'add') {
        return '添加分组';
      } else if (props.dialogType === 'edit') {
        return '修改分组';
      }
    });
    watch(() => props.dialogVisible, newValue => {
      if (newValue && props.dialogType === 'edit') {
        form.name = props.itemData.name;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "分组名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "请输入分组名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});